import { STORAGE_KEY, emptyGuest } from './state'

function persistToStorage(state) {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    // Sesión sin sessionStorage disponible: no es crítico.
  }
}

function clearStorage() {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignored
  }
}

export default {
  setGuestSession(state, payload) {
    const next = { ...state, ...(payload || {}) }
    Object.assign(state, next)
    persistToStorage(state)
  },
  patchGuestSession(state, payload) {
    if (!payload || typeof payload !== 'object') return
    Object.assign(state, payload)
    persistToStorage(state)
  },
  resetGuestSession(state) {
    Object.assign(state, emptyGuest())
    clearStorage()
  },
}
